















import { defineComponent } from '@vue/composition-api';

// static component
// [功能说明]: 可提现额度展示组件
interface Props {
  title?: string;
  currency?: string;
  value?: string;
}

export default defineComponent({
  name: 'AmountDisplay',
  props: {
    title: {
      type: String,
      default: '可提现额度(元)',
    },
    currency: {
      type: String,
      default: '¥',
    },
    value: {
      type: String,
      default: '6,000',
    },
  },
});
